export default __webpack_public_path__ + "static/media/invocom-todo.4510f801.svg";